<template>
    <div class="mainHeroMenu">
        <ul id="mainHeroMenuList">
            <MenuItem :item="menuItem" :key="buildKey(menuItem)" v-for="menuItem in menuList"/>
        </ul>
    </div>
</template>

<script>
    import MenuItem from './MenuItem.vue';

    export default {
    components: { MenuItem },
    props: {
      menuList: {
        type: Array,
        required: true,
        default: () => ([]),
      },
    },
    methods: {
      buildKey(item) {
        return item.title.replace(/[\W_]+/g, '');
      },
    },
  };
</script>
